import React, { useState, useEffect } from 'react';
import { emitServerStatus } from '../api';

export default function ServerBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handler = (e) => setShow(e.detail?.down ?? false);
    window.addEventListener('server-status', handler);
    return () => window.removeEventListener('server-status', handler);
  }, []);

  const dismiss = () => setShow(false);

  if (!show) return null;

  return (
    <div className="server-banner">
      <span>Server unavailable (502). Start the backend: <code>cd /root/gv-security && pm2 start ecosystem.config.js</code></span>
      <button onClick={dismiss} className="server-banner-dismiss">×</button>
    </div>
  );
}
